import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NoPage = () => {
    let navigate = useNavigate();
    const [windowLocation, setWindowLocation] = useState(window.location);
    useEffect(() => {
        if (windowLocation) {
            switch (windowLocation.pathname) {
                case "/borrow101":
                    {
                        navigate("/know");
                        break;
                    }
                case "/borrow101/family-friends-loans-taxes":
                    {
                        navigate("/know/taxes-implications-lending-borrowing-family-friends");
                        break;
                    }
                case "/borrow101/lend-interest":
                    {
                        navigate("/know/charge-interest-family-friend-loan");
                        break;
                    }
                case "/borrow101/common-lending-mistakes":
                    {
                        navigate("/know/avoid-common-lending-pitfalls-relationship-issues-regrets");
                        break;
                    }
                case "/borrow101/pros-cons-conventional-loans":
                    {
                        navigate("/know/alternatives-to-conventional-bank-loans-advantages");
                        break;
                    }
                case "/product-manage":
                    {
                        navigate("/product-lend");
                        break;
                    }
                default:
                    {
                        navigate("/");
                    }
            }
        }
    }, [windowLocation]);
    return (<h1>"No page found"</h1>);
};


export default NoPage;